import { fromJS } from 'immutable';
import {
  FETCH_AUTOMATED_BROADCAST_REQUEST,
  FETCH_AUTOMATED_BROADCAST_SUCCESS,
  FETCH_AUTOMATED_BROADCAST_FAILURE,
  FETCH_AUDIENCES_REQUEST,
  FETCH_AUDIENCES_SUCCESS,
  FETCH_AUDIENCES_FAILURE,
  SEARCH_AUTOMATED_BROADCAST_SUCCESS,
  SHOW_ERROR,
  TOGGLE_ERROR_MODAL,
  HANDLE_DROP_SUCCESS,
  HANDLE_DROP_FAILURE,
  HANDLE_REMOVE_SUCCESS,
  HANDLE_REMOVE_FAILURE,
  UPDATE_AUTOMATED_REQUEST,
  UPDATE_AUTOMATED_SUCCESS,
  UPDATE_AUTOMATED_FAILURE,
  HANDLE_SELECT_ABNODE,
  PUSH_INTO_UNDO_STACK,
  UNDO_SUCCESS,
  UNDO_FAILURE,
  CHANGE_PROPERTIES
} from './constants';

const initialState = fromJS({
  appError: {},
  isOpenErrorModal: false,
  automatedBroadcasts: [],
  isFetchingAutomatedBroadcasts: false,
  audiences: [],
  isFetchingAudiences: false,
  searchResult: [],
  isUpdatingAutomated: false,
  stateHistory: {
    limit: 100,
    currentIndex: -1,
    canUndo: false,
    canRedo: false,
    recovery: []
  },
  nodeSelected: {}
});

export default (state = initialState, action) => {
  switch (action.type) {
    /** FETCH AUTOMATED BROADCAST */
    case FETCH_AUTOMATED_BROADCAST_REQUEST:
      return state
        .set('automatedBroadcasts', fromJS([]))
        .set('isFetchingAutomatedBroadcasts', true);
    case FETCH_AUTOMATED_BROADCAST_SUCCESS:
      return state
        .set('automatedBroadcasts', fromJS(action.automatedBroadcasts))
        .set('isFetchingAutomatedBroadcasts', false);
    case FETCH_AUTOMATED_BROADCAST_FAILURE:
      return state
        .set('automatedBroadcasts', fromJS([]))
        .set('isFetchingAutomatedBroadcasts', false)
        .set('isOpenErrorModal', true)
        .set('appError', fromJS(action.appError));

    /** FETCH AUDIENCES */
    case FETCH_AUDIENCES_REQUEST:
      return state
        .set('audiences', fromJS([]))
        .set('isFetchingAudiences', true);
    case FETCH_AUDIENCES_SUCCESS:
      return state
        .set('audiences', fromJS(action.audiences))
        .set('isFetchingAudiences', false);
    case FETCH_AUDIENCES_FAILURE:
      return state
        .set('audiences', fromJS([]))
        .set('isFetchingAudiences', false)
        .set('isOpenErrorModal', true)
        .set('appError', fromJS(action.appError));

    /** SEARCH AUTOMATED BROADCAST */
    case SEARCH_AUTOMATED_BROADCAST_SUCCESS:
      return state.set('searchResult', fromJS(action.searchResult));

    /** SHOW ERROR */
    case SHOW_ERROR:
      return state
        .set('appError', fromJS(action.payload))
        .set('isOpenErrorModal', true);

    /** TOGGLE ERROR MODAL */
    case TOGGLE_ERROR_MODAL:
      return state.set('isOpenErrorModal', false);

    /** HANDLE DROP */
    case HANDLE_DROP_SUCCESS:
      return state.set('automatedBroadcasts', fromJS(action.automatedBroadcasts));
    case HANDLE_DROP_FAILURE:
      return state
        .set('isOpenErrorModal', true)
        .set('appError', fromJS(action.appError));

    /** HANDLE REMOVE */
    case HANDLE_REMOVE_SUCCESS:
      return state.set('automatedBroadcasts', fromJS(action.automatedBroadcasts));
    case HANDLE_REMOVE_FAILURE:
      return state
        .set('isOpenErrorModal', true)
        .set('appError', fromJS(action.appError));

    /** UPDATE AUTOMATED */
    case UPDATE_AUTOMATED_REQUEST:
      return state.set('isUpdatingAutomated', true);
    case UPDATE_AUTOMATED_SUCCESS:
    case UPDATE_AUTOMATED_FAILURE:
      return state.set('isUpdatingAutomated', false);

    /** HANDLE SELECT AB NODE */
    case HANDLE_SELECT_ABNODE:
      return state.set('nodeSelected', fromJS(action.payload));

    /** PUSH INTO UNDO STACK */
    case PUSH_INTO_UNDO_STACK:
      return state.set('stateHistory', fromJS(action.stateHistory));

    /** HANDLE UNDO */
    case UNDO_SUCCESS:
      return state
        .set('stateHistory', fromJS(action.stateHistory))
        .set('automatedBroadcasts', fromJS(action.automatedBroadcasts));
    case UNDO_FAILURE:
      return state
        .set('isOpenErrorModal', true)
        .set('appError', fromJS(action.appError));

    case CHANGE_PROPERTIES: {
      const abIndex = state.get('automatedBroadcasts').findIndex(ab => ab.get('id') === action.payload.abId);
      if (action.payload.delay) {
        return state.setIn(['automatedBroadcasts', abIndex, 'delay'],
          fromJS(action.payload.delay));
      }
      if (action.payload.locations) {
        return state.setIn(['automatedBroadcasts', abIndex, 'locations'],
          fromJS(action.payload.locations));
      }
      return state;
    }

    /** DEFAULT */
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/containers/onboarder/reducer.js